<ng-container *ngIf="hasConfiguration$ | async; else noValue">
   <iframe
      [ngClass]="(isWindowDraggedOrResized$ | async) ? 'sam-cursor-disabled' : ''"
      [src]="url$ | async"
      (load)="loadingCompleted()"
      fxFlexFill
      #iframe
   ></iframe>
   <samweb-loading-indicator *ngIf="isLoading$ | async" [runForever]="true"></samweb-loading-indicator>
</ng-container>

<ng-template #noValue>
   <div fxLayout="column" fxLayoutAlign="center center" fxFlexFill class="sam-margin">
      <fa-icon [icon]="dashboardIcon" size="3x"></fa-icon>
      <span class="sam-margin sam-text-center">
         {{ 'brick.brick_definitions.grafana_dashboard_viewer.no_dashboard_selected' | translate }}
      </span>
   </div>
</ng-template>
